"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  AppContext: () => AppContext,
  __getRoot: () => __getRoot,
  createBrowserHistory: () => createBrowserHistory,
  createHashHistory: () => createHashHistory,
  createMemoryHistory: () => createMemoryHistory,
  renderClient: () => renderClient,
  useAppData: () => useAppData
});
module.exports = __toCommonJS(src_exports);
var import_react = __toESM(require("react"));
var import_client = __toESM(require("react-dom/client"));
var import_jsx_runtime = require("react/jsx-runtime");
var root = null;
function __getRoot() {
  return root;
}
var AppContext = import_react.default.createContext(
  {}
);
function useAppData() {
  return import_react.default.useContext(AppContext);
}
var UMI_CLIENT_RENDER_REACT_PLUGIN_LIST = [
  // Lowest to the highest priority
  "innerProvider",
  "i18nProvider",
  "accessProvider",
  "dataflowProvider",
  "outerProvider",
  "rootContainer"
];
var getBrowser = (opts) => {
  const basename = opts.basename || "/";
  let rootContainer = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Fragment, {});
  for (const key of UMI_CLIENT_RENDER_REACT_PLUGIN_LIST) {
    rootContainer = opts.pluginManager.applyPlugins({
      type: "modify",
      key,
      initialValue: rootContainer,
      args: {
        plugin: opts.pluginManager
      }
    });
  }
  const Browser = () => {
    (0, import_react.useLayoutEffect)(() => {
      if (typeof opts.callback === "function")
        opts.callback();
    }, []);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      AppContext.Provider,
      {
        value: {
          pluginManager: opts.pluginManager,
          rootElement: opts.rootElement,
          basename
        },
        children: rootContainer
      }
    );
  };
  return Browser;
};
function renderClient(opts) {
  const rootElement = opts.rootElement || document.getElementById("root");
  const Browser = getBrowser(opts);
  if (import_client.default.createRoot) {
    root = import_client.default.createRoot(rootElement);
    root.render(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(Browser, {}));
    return;
  }
  import_client.default.render(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(Browser, {}), rootElement);
}
var createHashHistory = () => {
};
var createMemoryHistory = () => {
};
var createBrowserHistory = () => {
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppContext,
  __getRoot,
  createBrowserHistory,
  createHashHistory,
  createMemoryHistory,
  renderClient,
  useAppData
});
